module.exports = __webpack_public_path__ + "assets/img/process-3.31423346.png";